import { createFileRoute } from "@tanstack/react-router";
import { useRole } from "@/hooks/use-role";
import { PermissionDeniedPage } from "@/components/team/PermissionDeniedPage";
import { parseHubFilters } from "@/components/outreach/hub-filters";
import { OutreachWizard } from "@/components/outreach/OutreachWizard";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/_app/_/outreach/new")({
	// Hub filters are forwarded here so the wizard's "Back to outreach" returns
	// to the same filtered view the user started from.
	validateSearch: parseHubFilters,
	component: NewOutreachPage,
});

function NewOutreachPage() {
	const { isReadWrite } = useRole();
	if (!isReadWrite) {
		return (
			<PermissionDeniedPage
				requiredRole="Read/Write"
				message="You need Read/Write or Admin access to create an outreach campaign."
			/>
		);
	}
	return <NewOutreachPageInner />;
}

function NewOutreachPageInner() {
	const session = useSession();
	const campaignId = session.campaign?.id;
	const filters = Route.useSearch();
	if (!campaignId) {
		return (
			<div className="mx-auto max-w-3xl p-6">
				<p className="text-muted-foreground">
					No campaign found. Please complete onboarding first.
				</p>
			</div>
		);
	}
	return (
		<OutreachWizard
			campaignId={campaignId}
			accountName={session.campaign?.name ?? undefined}
			backSearch={filters}
		/>
	);
}
